import { ListProvider } from "./list-provider";
import { User } from "../../../../business-objects/user/user.model";
import { UserStoreFacade } from "../../../../business-objects/user/user.store-facade";

export class DummyListProvider extends ListProvider<User> {

    getFacade(): UserStoreFacade {
        return this.appFacade.objects.user.store;
    }

    getPrimaryField(item: User): string {
        return item && item.name;
    }

    getSecondaryField(item: User): string {
        return item && item.email;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/dummy-list-provider.ts